<template>
  <b-modal :title="$t('labels.provider_upload_report')"
           dialog-class="modal-lg"
           :modelValue="provider !== null"
           footer-class="d-flex justify-content-end"
           @update:modelValue="$event === false && (provider = null)">
    <template #default>
      <LoaderWrapper ref="loader" class="h-100">
        <div class="p-3 row pt-0">
          <div class="col-sm-12">

            <div class="row mt-2">
              <label for="fromDate" class="col-sm-4 col-form-label text-capitalize-first">{{ $t("labels.from_date") }}</label>
              <div class="col-sm-8">
                <div class="form-check form-switch d-flex align-items-center">
                  <DatePicker v-model="filters.fromDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                    <template v-slot="{ inputValue, togglePopover, inputEvents }">
                      <input
                        class="form-control form-control-sm"
                        :placeholder="$t('labels.from_date')"
                        :value="inputValue"
                        @focus="togglePopover"
                        @change="inputEvents.change"
                      />
                    </template>
                  </DatePicker>
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <label for="toDate" class="col-sm-4 col-form-label text-capitalize-first">{{ $t("labels.to_date") }}</label>
              <div class="col-sm-8">
                <div class="form-check form-switch d-flex align-items-center">
                  <DatePicker v-model="filters.toDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                    <template v-slot="{ inputValue, togglePopover, inputEvents }">
                      <input
                        class="form-control form-control-sm"
                        :placeholder="$t('labels.to_date')"
                        :value="inputValue"
                        @focus="togglePopover"
                        @change="inputEvents.change"
                      />
                    </template>
                  </DatePicker>
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <label for="fieldId" class="col-sm-4 col-form-label text-capitalize-first">{{ $t("labels.columns_mapping") }}:</label>
            </div>

            <div class="row mt-2">
              <label for="mappingInvoiceId" class="col-sm-4 col-form-label text-capitalize-first">{{ $t("labels.our_id") }}</label>
              <div class="col-sm-8">
                <div class="form-check form-switch d-flex align-items-center">
                  <input  v-model="filters.mappingInvoiceId" type="text" class="form-control" placeholder="A" id="mappingInvoiceId">
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <label for="mappingProviderId" class="col-sm-4 col-form-label text-capitalize-first">{{ $t("labels.provider_id") }}</label>
              <div class="col-sm-8">
                <div class="form-check form-switch d-flex align-items-center">
                  <input  v-model="filters.mappingProviderId" type="text" class="form-control" placeholder="B" id="mappingProviderId">
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <label for="mappingStatus" class="col-sm-4 col-form-label text-capitalize-first">{{ $t("labels.status") }}</label>
              <div class="col-sm-8">
                <div class="form-check form-switch d-flex align-items-center">
                  <input  v-model="filters.mappingStatus" type="text" class="form-control" placeholder="C" id="mappingStatus">
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <label for="mappingStatusCompleted" class="col-sm-4 col-form-label text-capitalize-first">{{ $t("labels.completed_status") }}</label>
              <div class="col-sm-8">
                <div class="form-check form-switch d-flex align-items-center">
                  <input  v-model="filters.mappingStatusCompleted" type="text" class="form-control" placeholder="completed" id="mappingStatusCompleted">
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <label for="mappingFiatSum" class="col-sm-4 col-form-label text-capitalize-first">{{ $t("labels.fiat_sum") }}</label>
              <div class="col-sm-8">
                <div class="form-check form-switch d-flex align-items-center">
                  <input  v-model="filters.mappingFiatSum" type="text" class="form-control" placeholder="D" id="mappingFiatSum">
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <label for="mappingRewardPercent" class="col-sm-4 col-form-label text-capitalize-first">{{ $t("labels.reward_rate") }}</label>
              <div class="col-sm-8">
                <div class="form-check form-switch d-flex align-items-center">
                  <input  v-model="filters.mappingRewardPercent" type="text" class="form-control" placeholder="E" id="mappingRewardPercent">
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <label for="mappingRate" class="col-sm-4 col-form-label text-capitalize-first">{{ $t("labels.rate") }}</label>
              <div class="col-sm-8">
                <div class="form-check form-switch d-flex align-items-center">
                  <input  v-model="filters.mappingRate" type="text" class="form-control" placeholder="F" id="mappingRate">
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <label for="mappingRowNum" class="col-sm-4 col-form-label text-capitalize-first">{{ $t("labels.row_number") }}</label>
              <div class="col-sm-8">
                <div class="form-check form-switch d-flex align-items-center">
                  <input  v-model="filters.mappingRowNum" type="text" class="form-control " id="mappingRowNum">
                </div>
              </div>
            </div>

            <div class="row mt-2" v-if="!fileAttachment">
              <div class="col-sm-12">
                <div style="cursor: pointer; border:1px dashed" v-bind="dropzone.getRootProps()" class="payout-dropzone rounded border-secondary p-3 pt-4 pb-4 d-flex justify-content-center align-items-center">
                  <input v-bind="dropzone.getInputProps()" />
                  <p class="p-0 m-0">{{ helper.trans('labels.payout_upload_files')}}</p>
                </div>
              </div>
            </div>
            <div v-if="fileAttachment" class="row mt-2">
              <div class="col-sm-12">
                <i class="fa fa-paperclip"></i> <span class="me-2">{{ fileAttachment?.file.name}}</span>
                <a href="#" @click.prevent="removeFile()">
                  <i class="fa fa-times"></i>
                </a>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-sm-12">
                <button @click.prevent="uploadForm()" :disabled="!fileAttachment" class="btn w-100 btn-outline-success">{{$t('labels.check_report')}}</button>
              </div>
            </div>

            <div class="row mt-2" v-if="checkResult">
              <div class="col-sm-12">
                {{ $t('labels.check_report_diff_count') }} {{checkResult.diffCount}}
              </div>
              <div class="col-sm-12" v-if="checkResult.diffSum">
                {{ $t('labels.check_report_diff_sum') }} {{numberFormatter.formatMoney(checkResult.diffSum)}}
              </div>
              <div class="col-sm-12" v-if="checkResult.diffAttachment">
                <a :href="`${api.baseUrl()}/attachments/${checkResult.diffAttachment}`" target="_blank">{{$t('labels.download_report')}} <i class="fa fa-paperclip"></i></a>
              </div>
            </div>

          </div>
        </div>

      </LoaderWrapper>
    </template>
    <template #footer>
      <button type="button" @click.prevent="provider = null" class="btn btn-outline-dark btn-sm text-capitalize-first">
        {{ helper.trans('button.ok')  }}
      </button>
    </template>
  </b-modal>
</template>

<script lang="ts">

import {defineComponent, PropType, Prop, watch, ref} from 'vue'
import {$t, helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import {api} from "@/service/APIClient";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {BModal, BPagination} from "bootstrap-vue-3";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {DatePicker} from "v-calendar";
import CopyButton from "@/components/CopyButton.vue";
import moment from "moment";
import ProviderDTO from "@/models/ProviderDTO";
import {useDropzone} from "vue3-dropzone";

interface AttachmentFileDTO {
  id: number;
  file: File,
}

let id = 1;
export default defineComponent({
  methods: {$t},
  components: {
    CopyButton,
    BPagination,
    DatePicker,
    LoaderWrapper,
    BModal,
  },
  setup() {
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const defaultFilters = {
      fromDate: null,
      toDate: null,
      mappingInvoiceId: null,
      mappingProviderId: null,
      mappingStatus: null,
      mappingStatusCompleted: null,
      mappingFiatSum: null,
      mappingRate: null,
      mappingRewardPercent: null,
      mappingRowNum: 2
    } as any;

    const state = reactive({
      fileAttachment: null as AttachmentFileDTO|null,
      filters: {...defaultFilters} as any,
      provider: null as ProviderDTO|null,
      checkResult: null as any|null
    });

    const onDrop = async (acceptFiles: any, rejectReasons: any) => {
      for (const file of acceptFiles) {
        state.fileAttachment = {
          id: id++,
          file,
        } as AttachmentFileDTO
        break;
      }
    }
    const dropzone = useDropzone({ onDrop, accept:['.xlsx'], multiple: false, maxFiles: 1 });

    const show = (provider: ProviderDTO) => {
      state.filters = {...defaultFilters}
      state.provider = provider
      state.fileAttachment = null
      state.checkResult = null
    }

    const removeFile = () => {
      state.fileAttachment = null
    }

    const uploadForm = async () => {
      if (!state.fileAttachment || !state.provider) {
        return;
      }

      state.checkResult = null;
      loader.value?.show()

      try {
        state.checkResult = await api.call.providers.reportCheckUpload(state.provider.id, {
          ...state.filters,
          fromDate: dateHelper.toUTC(state.filters.fromDate),
          toDate: dateHelper.toUTC(state.filters.toDate),
          file: state.fileAttachment!.file
        });
      } finally {
        loader.value?.hide()
      }

    }

    return {
      ...toRefs(state),
      show,
      dropzone,
      loader,
      removeFile,
      dateHelper,
      numberFormatter,
      uploadForm,
      helper,
      api
    }
  }
})
</script>
